import AjaxService from '@/util/ajaxService.js';
import MessageService from '@/util/messageService.js';
import DownloadService from '@/assets/services/downloadService.js'
import DomToImage from 'dom-to-image'
import qrcode from 'vue_qrcodes'
import html2canvas from 'html2canvas'
import logo from '../../../static/img/ktbLogo.jpg'

export default {
  name: 'custProject',
  mixins: [],
  extends: {},
  components: {
    qrcode
  },
  props: [],
  data() {
    return {
      groupId: null,
      memberId: null,
      isShowPromo: false,
      isShowProject:false,
      promo:null,
      project: null,
      showPromoInfo: false,
      url: null,
      iconUrl: null,
      dataClipboardText:null,
      qrCode: null,
      showProjectInfo: false,
      showProjectInfoDetail: false,
      projectOptionList: null,
      curPageList: [],
      queryList: [],
      promoList: [],
      successList: [],
      marketingList:null,
      logo: logo,
      // 轉寄
      formForward: {
          name: null,
          email: null,
      },
      marketingId: null, 
      forwardModel: false,

      // 檢核碼相關
      captchaImg: null,
      captchaCode: null,
      captchaVerifyCode: null,
      openCheckCode: true,
    };
  },
  computed: {
    isShowGetPromotBtn: function () {
      return this.url == null;
    },
    isShowGetProjectBtn: function () {
      return !this.showProjectInfo;
    },
  },
  watch: {
    promo(p){
      this.url = null;
      // this.logo = null;
      this.iconUrl = null;
      this.showPromoInfo = false;
      this.marketingId = null;
    },
    project(){
      this.showProjectInfo = false;
      this.showProjectInfoDetail = false;
    },
    captchaCode() {
      if (this.captchaCode) {
        this.captchaCode = this.removeNonNumeric(this.captchaCode);
      }
    },
  },
  created() { },
  mounted() {
    this.init();
  },
  updated() { },
  beforeDestroy() { },
  methods: {
    // 初始化
    init() {

      // 取得檢核碼
      this.getCaptchaCode();
    },

    // 取得檢核碼
    getCaptchaCode() {
      AjaxService.post("/oasPromo/custProject/getCaptchaCode", {},
        (succesResponse) => {
          if (succesResponse.restData) {
            this.captchaImg = `data:image/jpeg;base64,${succesResponse.restData.data}`;
            this.captchaVerifyCode = succesResponse.restData.text;
            this.captchaCode = null;
            this.openCheckCode = true;
          } else {
            this.openCheckCode = false;
          }
        },
        (errorResponse) => {
          MessageService.showError(this.$t(`contentMap.${errorResponse.appMsg}`));
        }
      );
    },

    getProjectOption() {
      AjaxService.post("/oasPromo/custProject/getProjectOption", {
          groupId: this.groupId,
          rocId: this.memberId,
          captchaCode: this.captchaCode,
          captchaVerifyCode: this.captchaVerifyCode,
        },
        successResp => {
          this.getCaptchaCode();
          this.isShowProject = true;
          this.projectOptionList = successResp.restData;
        },
        errorResp => {
          MessageService.showError(errorResp.appMsg);
        }
      );
    },

    // 取得推廣資訊
    getPromoModel() {
      if(this.verifyPromoGroupMember()){
        this.getGroupMarketing();
      }
    },

    // 取得專案資訊
    getProjectModel() {
      if(this.verifyPromoGroupMember()){
        this.getProjectOption();
      }
    },

    // 驗證使用者
    verifyPromoGroupMember() {
      // 推廣群組代碼
      const groupId = this.groupId;
      // 推廣群組驗證
      const groupPattern = new RegExp(/^[K][T][B][0-9a-zA-Z]{5}$/);
      // 人員識別碼
      const memberId = this.memberId;

      if (groupId == null || groupId == "") {
        MessageService.showError("未輸入推廣群組代碼");
        return false;
      }
      if(!(groupPattern.test(groupId))){
        MessageService.showError("推廣群組代碼格式有誤");
        return false;
      }
      if (memberId == null || memberId == "") {
        MessageService.showError("未輸入人員識別碼");
        return false;
      }

      // 未輸入圖形驗證碼
      if (!this.captchaCode && this.openCheckCode) {
        MessageService.showError('請輸入檢核碼');
        return false;
      }
      return true;
    },

    // 取得第三方推廣群組現有專案
    getGroupMarketing(){
      const data = {
        "groupId": this.groupId,
        "memberId": this.memberId,
        "captchaCode": this.captchaCode,
        "captchaVerifyCode": this.captchaVerifyCode,
      };
      AjaxService.post("/oasPromo/custProject/queryGroupMarketing", data,
        successResp => {
          this.getCaptchaCode();
          this.marketingList = successResp.restData;
          this.isShowPromo = true;
        },
        errorResp => {
          console.log(errorResp.appMsg);
          MessageService.showError(errorResp.appMsg);
        }
      );
    },
    // 取得推廣網址資訊
    getPromoInfo() {
      const index = this.promo;  
      if(index != null){
        const marketingIdPattern = new RegExp(/^[M][A][R][K][0-9]{8}$/);
        if(!(marketingIdPattern.test(this.marketingList[index]['id']))){
          MessageService.showError("專案代碼格式有誤");
          return;
        }
        this.marketingId = this.marketingList[index]['id']
        const data = {
          "marketingId": this.marketingId,
          "groupId": this.groupId,
          "rocId": this.memberId
        };
        AjaxService.post("/oasPromo/custProject/queryPromoUrl", data,
          successResp => {
            this.url = successResp.restData.url;
            this.qrCode = require('../../../static/img/customerInfo.png');
            this.showPromoInfo = true;
          },
          errorResp => {
            MessageService.showError(errorResp.appMsg);
          }
        );
      }
      else{
        MessageService.showError("請選擇專案");
      }
    },
    // 確定or取消取得推廣資訊的model
    canclePromoModel() {
      this.showPromoInfo = false;
      this.isShowPromo = false;
      this.url = null;
      this.qrCode = null;
      this.promo = null;
    },

    // 複製推廣連結成功
    copyPromoSucess(){
      MessageService.showSuccess("連結複製成功");
    },
    // 複製推廣連結失敗
    copyPromoError(){
      MessageService.showError("連結複製失敗");
    },

    // 下載推廣連結
    downloadPromoURL(){
      let self = this;
				// // 取得節點
				let node = document.getElementById('qrCode');
				let ua = navigator.userAgent.toLocaleLowerCase();
				
				// for IE
				if(ua.match(/msie/) != null || ua.match(/trident/) != null) {
                    console.log('上面')
					document.documentElement.scrollTop = 0
					document.body.scrollTop = 0
					html2canvas(node).then(canvas => {
						var image = canvas.toDataURL("image/png", 1.0);
						var blob = self.b64toBlob(image);
            DownloadService.download(blob, 'promoURL.png');
            MessageService.showSuccess("連結下載");
					});
				}else{
          console.log('下面')
					// // 下載客戶資訊的png圖檔
					DomToImage.toBlob(node).then((blob) => {
            DownloadService.download(blob, 'promoURL.png')
            MessageService.showSuccess("連結下載");
					}).catch(function (error) {
						MessageService.showError('錯誤', '下載失敗');
					});
				}
    },
    // base64 轉 blob
    b64toBlob(dataURI) {

      var byteString = atob(dataURI.split(',')[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/png' });
    },

    // 取得推廣結果明細
    promoDetail() {
      this.queryList = {
        groupId: this.groupId,
        memberId: this.memberId,
        cfgMarkingId: this.project
      }  
      AjaxService.post("/oasPromo/custProject/getCustProjectDetail",this.queryList,
        (data) => {
          if (data.restData != null) {
            this.showProjectInfoDetail = true;
            this.successList = data.restData;

          } else {
            this.successList = [];
          }
        },
        (error) => {
          MessageService.showError(error.appMsg);
        });
    },

    // 查詢專案推廣結果
    getProjectInfo() {
      if (this.project == null) {
        MessageService.showError("未選擇專案");
        return;
      }

      this.queryList = {
        groupId: this.groupId,
        rocId: this.memberId,
        marketingId: this.project
      }

      // 取得推廣成績
      AjaxService.post("/oasPromo/custProject/getCustProjectReport", this.queryList,
      (data) => {
        this.showProjectInfo = true;
        this.curPageList = data.restData;

      },
      (error) => {
        MessageService.showError(error.appMsg);
      });
    },

    // 確認or取消查詢推廣成績的model
    cancleProjectModel() {
      this.showProjectInfo = false;
      this.showProjectInfoDetail = false;
      this.project = null;
      this.isShowProject = false;
    },
    removeNonNumeric(text) {
      return text.replace(/[^\d]/,'');
    },

    // 轉寄信件相關
    // 轉寄
    forward() {
      this.forwardModel = true;
    },
    // 送出表單
    submit() {
      const emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if( !this.formForward.email || !emailRule.test(this.formForward.email)) {
        MessageService.showError('請填寫正確 email');
        return;
      }
      
      if( !this.formForward.name) {
        this.formForward.name = '客戶';
      }


      AjaxService.post("/oasPromo/custProject/forward", {
          email: this.formForward.email,
          name: this.formForward.name,
          promoUrl: this.url,
          marketingId: this.marketingId,
        },
        successResp => {
          this.$bvModal.hide("submit-modal");
          MessageService.showSuccess('成功');
          this.reset();
        },
        errorResp => {
          this.$bvModal.hide("submit-modal");
          MessageService.showError('失敗' || error.appMsg);
          this.reset();
        }
      );
    },
    // 取消
    reset() {
      this.forwardModel = false;
      this.formForward.name = null;
      this.formForward.email = null;
    },
    

  },
};



// WEBPACK FOOTER //
// ./src/components/custProject/custProject.js